var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-checkbox-group',{on:{"change":_vm.onCheckboxChange},model:{value:(_vm.vals),callback:function ($$v) {_vm.vals=$$v},expression:"vals"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }